import React from 'react';

const Blogs = () => {
    return (

        <section className='py-5'>
            <div className="container">
                <h2 className='text-center pt-3 fw-bold' style={{ color: "rgba(25, 95, 75, 77)" }}>Answer to the Question</h2>
                <hr />
                <div className="row g-md-3 g-3">
                    <div className="col-md-4">
                        <div className='p-3 shadow-lg rounded-3 '>
                            <div>
                                <h4 className='text-success'>Difference between authorization and authentication?</h4>
                                <hr />
                            </div>
                            <div>
                                <p>Authentication is the process of verifying a person's identity, while authorization is the procedure that follows authentication. It's the method of deciding which apps, files, and other resources a user owns. In the digital world, authentication is used to verify that persons are who they claim they are. Following that, authorization is used to grant a user access to specific types of information or services.</p>
                            </div>
                        </div>
                    </div>
                    <div className='col-md-4'>
                        <div className="p-3 shadow-lg rounded-3">
                            <div>
                                <h4 className='text-success'>Why are we using firebase? What other options do you have to implement authentication?</h4>
                                <hr></hr>
                            </div>
                            <div>
                                <p>For a variety of reasons, we use Firebase. The main reason for this is because Firebase offers interactive Realtime Database apps for secure authentication, and realtime events continue to fire even when the user is offline. And it came from Google, the largest firm on the planet. We're all confident in Google's robust security mechanism. As a result, we have confidence in the Firebase security mechanism. It's also simple to use and includes a comprehensive set of services. The following are some of the Firebase options: Many other companies are similar to Firebase, including Parse, Back4App, AWS Amplify, Kuzzle, Couchbase, NativeScript, RxDB, Flutter, and others.</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="p-3 shadow-lg rounded-3 ">
                            <div>
                                <h4 className='text-success'>What other services does firebase provide other than authentication?</h4>
                                <hr></hr>
                            </div>
                            <div>
                                <p>Aside from authentication, Firebase has a slew of other capabilities. Firebase's core tool, Analytic, gives us such a detailed image of our product that it can help us grow and establish marketing strategies. It's also absolutely free. The second option is Remote Configuration, which, depending on how we use it, allows us to do A/B testing, give a personalized experience, and much more. Databse is in third place. "Extremely wonderful!" is one way to describe the Firebase Database. It provides us with two different types of databases. Firebase Cloud Firestore is used to power this real-time database. Cloud Messaging is number four on the list of time savers. It can be used to choose user categories for push notifications, as well as to study the percentage of users who opened the notice after it was issued. Firebase's primary services are listed below. Authentication isn't the only thing that needs to be done.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Blogs;